import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import useConfigurations from '../../hooks/useConfigurations';
import { Configuration, CONFIGURATION_TYPE } from 'vendor-marketplace-shared-library';
import { getConfigurationValue } from '../../utilities/helpers';
import { useState } from 'react';
import { WarrantyNeededModal } from '../common/WarrantyNeededModal';

export default function CreateWorkOrderAction() {
  const navigate = useNavigate();
  const { configurationsQuery } = useConfigurations();
  const [open, setOpen] = useState(false);

  const userWarrantyProductIsEnabledConfiguration =
    configurationsQuery?.data?.getConfigurations?.find(
      (configuration: Configuration) =>
        configuration.name === CONFIGURATION_TYPE.WARRANTY_PRODUCT_IS_ENABLED,
    );

  const isUserWarrantyProductEnabled = getConfigurationValue(
    userWarrantyProductIsEnabledConfiguration,
  );

  const userNonWarrantyWorkOrderCreationIsEnabledConfiguration =
    configurationsQuery?.data?.getConfigurations?.find(
      (configuration: Configuration) =>
        configuration.name === CONFIGURATION_TYPE.NON_WARRANTY_WORK_ORDER_CREATION_IS_ENABLED,
    );

  const isUserNonWarrantyWorkOrderCreationEnabled = getConfigurationValue(
    userNonWarrantyWorkOrderCreationIsEnabledConfiguration,
  );

  const onClick = () => {
    if (isUserWarrantyProductEnabled || isUserNonWarrantyWorkOrderCreationEnabled) {
      navigate('/create-work-order');
      return;
    } else {
      setOpen(true);
    }
  };

  return (
    <>
      <Box sx={Styles.boxStyles}>
        <IconButton onClick={onClick} sx={{ backgroundColor: 'primary.main' }}>
          <AddIcon sx={{ color: 'white' }} fontSize={'large'} />
        </IconButton>
      </Box>
      {open && <WarrantyNeededModal open={open} setOpen={setOpen} />}
    </>
  );
}

const Styles = {
  boxStyles: {
    transform: 'translateZ(0px)',
    flexGrow: 1,
    position: 'fixed',
    bottom: 16,
    right: 16,
  },
};
